<template>
  <div class="container">
    <h1>Support & FAQ: My Global Radio Pro FM & AM</h1>
    <p>Everything you need to know about your new window to the world. If your question isn't answered below, please reach out!</p>

    <h2>Getting Started</h2>
    <dl>
        <dt>1. What makes My Global Radio Pro unique?</dt>
        <dd>We prioritize speed and a "Zero-Clutter" interface. No forced accounts and no intrusive video ads—just instant access to 40,000+ global streams.</dd>

        <dt>2. Is the app truly free to use?</dt>
        <dd>Yes. All core streaming and search features are free. We believe global news and music should be accessible to everyone.</dd>

        <dt>3. How many stations are available?</dt>
        <dd>Our database currently features over 40,000 live stations spanning every continent, from major networks like BBC and NPR to niche local broadcasters.</dd>

        <dt>4. Can I search for stations by genre?</dt>
        <dd>Absolutely. Type genres like "Jazz," "Classic Rock," "News," or "Lo-Fi" into the search bar to see a global list of matching stations.</dd>

        <dt>5. How do I find stations from a specific country or city?</dt>
        <dd>Simply type the location (e.g., "Germany," "Seattle," or "Tokyo") into the search bar to discover top broadcasters from that region.</dd>
    </dl>

    <h2>Technical & Playback</h2>
    <dl>
        <dt>6. Does the app support background play?</dt>
        <dd>Yes. You can lock your phone or use other apps while the music continues. You can control the stream directly from your iOS Lock Screen.</dd>

        <dt>7. Will the app work with my Bluetooth speakers or car?</dt>
        <dd>Yes. It is fully compatible with Bluetooth headphones, portable speakers, and vehicle Bluetooth systems.</dd>

        <dt>8. Does the app consume a lot of mobile data?</dt>
        <dd>Standard streams use roughly 30MB–60MB per hour. We recommend using Wi-Fi for long sessions if you have a limited data plan.</dd>

        <dt>9. Why does it take a few seconds for a station to start?</dt>
        <dd>The app establishes a high-quality buffer to ensure playback doesn't skip, even if your signal strength fluctuates slightly.</dd>

        <dt>10. Does the app have a Sleep Timer?</dt>
        <dd>We are currently working on a built-in timer. For now, you can use the iOS "Clock" app's timer with the "Stop Playing" setting.</dd>
    </dl>

    <h2>Troubleshooting</h2>
    <dl>
        <dt>11. The stream stopped playing. What should I do?</dt>
        <dd>This is usually due to a momentary drop in internet connection. Tap "Play" again to reconnect, or toggle your Wi-Fi off and on.</dd>

        <dt>12. Why am I seeing "Station Offline"?</dt>
        <dd>Some stations only broadcast during specific hours or may be experiencing server issues at the source. Try again in a few minutes.</dd>

        <dt>13. Why is the audio quality different between stations?</dt>
        <dd>Audio quality is determined by the broadcaster's bitrate. We always provide the highest-quality stream available from the station's source.</dd>

        <dt>14. Why is there a delay compared to my physical FM radio?</dt>
        <dd>Digital streams are processed and buffered to prevent lag, which usually results in a 10–30 second delay behind live terrestrial signals.</dd>

        <dt>15. The app is not producing sound even though it says "Playing."</dt>
        <dd>Check that your device's "Silent" switch is off and that your volume is turned up. Also, check if you are connected to a Bluetooth device.</dd>
    </dl>

    <h2>Personalization & Features</h2>
    <dl>
        <dt>16. How do I save a favorite station?</dt>
        <dd>Tap the Heart icon on any station list or the player screen. It will be instantly added to your "Favorites" tab.</dd>

        <dt>17. How can I remove a station from Favorites?</dt>
        <dd>Navigate to your Favorites tab and tap the Heart icon again to remove it, or use the "Edit" button to manage your list.</dd>

        <dt>18. Can I see what song is currently playing?</dt>
        <dd>If the broadcaster provides metadata, the song title and artist will appear automatically in the player.</dd>

        <dt>19. How do I share a station link with a friend?</dt>
        <dd>Tap the Share icon. Our "Deep Link" technology allows your friend to open the exact same station instantly in their app.</dd>

        <dt>20. Does the app show recently played stations?</dt>
        <dd>Yes, your most recently accessed stations are stored locally for quick access the next time you open the app.</dd>
    </dl>

    <h2>Privacy & Security</h2>
    <dl>
        <dt>21. Do I need to create an account?</dt>
        <dd>No. We believe in "Privacy by Design." You can use all features without ever sharing an email address or creating a password.</dd>

        <dt>22. Does the app track my location?</dt>
        <dd>No. We do not require GPS permissions. Your searches and listening habits stay private on your device.</dd>

        <dt>23. Does the app sell my data?</dt>
        <dd>Never. We do not collect personal data, so we have nothing to sell to third parties or advertisers.</dd>

        <dt>24. Why does the app need internet permissions?</dt>
        <dd>Internet access is strictly used to pull the live audio stream from the broadcaster's servers to your device.</dd>

        <dt>25. How can I request a missing station?</dt>
        <dd>We love adding new content! Email us at <a href="mailto:care@thewishboard.com">care@thewishboard.com</a> with the station name and city.</dd>
    </dl>

    <h2>Contact</h2>
    <p>Still need help? Email us: <a href="mailto:care@thewishboard.com">care@thewishboard.com</a></p>
  </div>
</template>

<script>
export default {
  name: 'GlobalRadioSupport'
};
</script>

<style scoped>
.container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 850px;
  margin: 0 auto;
  padding: 30px;
}
h1, h2 { color: #000; border-bottom: 1px solid #eaeaea; padding-bottom: 10px; margin-top: 40px; }
dt { font-weight: 700; margin-top: 25px; color: #222; font-size: 1.1rem; }
dd { margin-left: 0; color: #555; padding-top: 5px; border-bottom: 1px dotted #eee; padding-bottom: 15px; }
a { color: #007aff; text-decoration: none; }
a:hover { text-decoration: underline; }
</style>